import { Injectable, signal } from '@angular/core';
import { Uuid } from '../../../../../../../graphql';
import { GeneratedProvider } from '../../../../estimate-view/costings/ai-costings-calculator/domain/entities/provider-info-ai';
import { SmartEstimateProject } from '../entities/smart-est-project';

@Injectable({ providedIn: 'root' })
export class AiEstimateStoreService {
    sessionId = signal<Uuid | null>(null);
    projectTypes = signal<SmartEstimateProject[]>([]);
    userInput = signal<UserInput | null>(null);
    iD_SmartParameters = signal<Uuid | null>(null);
    smartParameters = signal<SmartParamsFromPrompt | null>(null);
    iD_Log = signal<Uuid | null>(null);
    categories = signal<SmartEstimateCategoryVM[] | null>(null);
    estimateCreateOptions?: EstimateCreateOptions;
    processingEstimate = signal<boolean>(false);
    estimateGenerationSummary = signal<EstimateSummary | null>(null);
    percentage = signal<number>(0);
    progressMessage = signal<string>('Analyzing requirements');
    connectionStatus = signal<GeneratedProvider[] | null>(null);
    selectedProvider = signal<GeneratedProvider | null>(null);

    reset() {
        this.sessionId.set(null);
        this.projectTypes.set([]);
        this.processingEstimate.set(false);
        this.userInput.set(null);
        this.iD_Log.set(null);
        this.iD_SmartParameters.set(null);
        this.categories.set(null);
        this.estimateCreateOptions = undefined;
        this.smartParameters.set(null);
        this.percentage.set(0);
        // TODO - localize the string (here and above)
        this.progressMessage.set('Analyzing requirements');
        this.connectionStatus.set(null);
        this.selectedProvider.set(null);
    }
}

type UserInput = {
    selectedProjectId: Uuid;
    projectDescription: string;
    jobLocation: string;
    jobCountry: string;
    jobState: string;
};

type SmartParamsFromPrompt = {
    area: number;
    excludedItems: string[];
    iD_LogParameter?: Uuid;
    iD_LogSelection?: Uuid;
    iD_Parameters: Uuid;
    location: string;
    uom: string;
};

type SmartEstimateCategoryVM = {
    iD_Category: Uuid;
    items?: SmartEstimateItemVM[];
    selected: boolean;
};

type SmartEstimateItemVM = {
    iD_Item: Uuid;
    selected: boolean;
};

type EstimateWorkLocation = {
    worksLocationAddress: string;
    worksLocationSuburb: string;
    worksLocationPostcode: string;
    worksLocationState: string;
    worksLocationLat: number;
    worksLocationLng: number;
};

type EstimateSummary = {
    summary: string;
    estimateId: Uuid;
};

type EstimateCreateOptions = { name?: string; leadId?: Uuid } & EstimateWorkLocation;
